import { createContext, useContext } from "react";
import { SettingsContextType } from "@/types/auth";

export const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export default function useSettings() {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
}
